module.exports = __webpack_public_path__ + "img/EnglishModel.1f0c442d.jpg";